export default __webpack_public_path__ + "static/media/avatar-group.94242b11.svg";